import { forwardRef } from 'react'
import Styles from './ImageEditor.module.scss'
import { Pressable } from '@react-aria/interactions'
import cx from 'classnames'
import { useObjectRef } from '@react-aria/utils'
import { Hotspot } from 'hooks/queries/designs/useHotspots'
import { Image03 } from 'blaze-ui/icons/24'

interface HotspotTriggerProps {
  hotspot: Hotspot
  index: number
  isEdited: boolean
  isRemoved: boolean
}

export const HotspotTrigger = forwardRef<HTMLElement, HotspotTriggerProps>(
  ({ hotspot, index, isEdited, isRemoved }, ref) => {
    const fRef = useObjectRef(ref)
    const isImageType = hotspot.subject_type === 'image'
    const testId = `hotspot-${index}`

    if (isImageType) {
      return (
        <Pressable ref={fRef}>
          <div
            data-testid={testId}
            className={cx(Styles.imageHotspot, { [Styles.imageHotspotEdited]: isEdited, [Styles.removed]: isRemoved })}
            style={{
              left: `calc(${(hotspot.x + hotspot.width / 2) * 100}%)`,
              top: `calc(${(hotspot.y + hotspot.height / 2) * 100}%)`,
            }}
          >
            <Image03 color="var(--light-100)" size={20} />
          </div>
        </Pressable>
      )
    }

    return (
      <Pressable ref={fRef}>
        <div
          data-testid={testId}
          className={cx(Styles.boundingBox, { [Styles.edited]: isEdited, [Styles.removed]: isRemoved })}
        />
      </Pressable>
    )
  },
)
